<div
  class="container-header"
  #tooltip="matTooltip"
  [matTooltip]="null"
  (mouseenter)="calculateIfTooltipNeeded()"
  (mouseleave)="headerMouseLeave()"
  [appPreventEvent]="eventNames.MOUSE_DOWN"
  [stopPropagationOnly]="true"
>
  <div #headerElement class="header-label">
    {{ header }}
  </div>
  <div class="additional-data">
    <ng-content select="[header]"></ng-content>
  </div>
</div>
